export function checkIsNavigatorActive(poweraApps, userGroups) {
  const navigatorPowerapp = findNavigatorByAlias('beebotnavigator', poweraApps);
  if(!navigatorPowerapp) {
    return false;
  }
  const { isActive, groupId, hasgroup } = navigatorPowerapp.attributes
  if (!isActive) return false
  userGroups = new Set(userGroups)
  const navigatorGroups = new Set(groupId)
  const userHasNavigatorGroups = userGroups.intersection(navigatorGroups)
  return hasgroup === 0 || userHasNavigatorGroups.size > 0
}

function findNavigatorByAlias(alias, poweraApps) {
  return poweraApps.find(app => app.attributes.alias === alias) || null;
}